import { machToggleLoadingScreen, machFixSvgInlineStylesConflicts } from "./main";
import { debounce } from "./main";

jQuery(document).ready(function () {
    jQuery(".stores-algolia-listing .store-filters-toggle").on("click", machToggleMobileStoresFilters);
    jQuery(".stores-algolia-listing .store-filters-close").on("click", machToggleMobileStoresFilters);

    jQuery(".stores-algolia-listing .store-categories-filter a:not('.store-filters-close'):not('.no-filter')").on("click", machHandleStoresFiltersQueryParams);
    jQuery("body").on("click", ".stores-algolia-listing .stores-pagination a", machHandleStoresFiltersQueryParams);
    jQuery(".stores-algolia-listing .stores-filters-form form").on("submit", machHandleStoresFiltersQueryParams);
    jQuery(".stores-algolia-listing .stores-filters-form select").on("change", machHandleStoresFiltersQueryParams);

    machStoresHandleScroll();
    jQuery(window).scroll(function () {
        debounce(machStoresHandleScroll, 25);
    });

    if (history.pushState) {
        let search_params = new URLSearchParams(window.location.search);
        //If any of the filters are in the URL, refresh the content on page load
        if (search_params.get("filter_page") || search_params.get("store_cat") || search_params.get("search") || search_params.get("filter_sort")) {
            machRefreshStores(search_params.toString());
        }
    }
});

/**
 * Function called when a filter store link is clicked, a pagination change is requested, the sort option is changed or when the search input has been submitted.
 * Used to dynamically add the filter params to the URL. We add the filters to the URL to make sure that when a user clicks "back" in his browser, he will keep the filters he was on.
 * When all the filters are in the URL, it triggers the AJAX call to refresh the content based on the URL parameters.
 */
function machHandleStoresFiltersQueryParams(e) {
    e.preventDefault();
    // If the browser supports pushState
    if (history.pushState) {
        let search_params = new URLSearchParams(window.location.search);

        //If the clicked object is a pagination link
        if (jQuery(this).hasClass("page-numbers")) {
            let pagination_link = jQuery(this).attr("href");
            let page_number_matches = pagination_link.match(/\/page\/(\d*)/);
            //If the regex found matches for a page number
            if (page_number_matches) {
                search_params.set("filter_page", page_number_matches[1]);
            } else {
                //If there's no page number found, remove the page param
                search_params.delete("filter_page");
            }
        } else if (jQuery(this).hasClass("store-filter-link")) {
            jQuery(this).parents(".store-categories-filter").find(".active").removeClass("active");
            jQuery(this).addClass("active");

            let selected_cat = jQuery(this).find(".store-cat-name").text();

            if (selected_cat) {
                search_params.set("store_cat", selected_cat);
            } else {
                search_params.delete("store_cat");
            }

            //If it's a category link being clicked, reset the pagination so we go back to the first page
            search_params.delete("filter_page");
        } else if (jQuery(this).is("form")) {
            //If the search input has been submitted, set the search URL param
            if (jQuery(this).find("[name='store_search']").val()) {
                search_params.set("search", jQuery(this).find("[name='store_search']").val());
            } else {
                search_params.delete("search");
            }
            //Reset the pagination so we go back to the first page
            search_params.delete("filter_page");
        } else if (jQuery(this).is("select")) {
            //If the sort select has been changed, set the sort URL param
            if (jQuery(this).val()) {
                search_params.set("filter_sort", jQuery(this).val());
            } else {
                search_params.delete("filter_sort");
            }
        }

        // The new url string
        let new_url = window.location.protocol + "//" + window.location.host + window.location.pathname;
        if (search_params.toString()) {
            new_url += "?" + search_params.toString();
        }
        window.history.pushState({ path: new_url }, "", new_url);

        // If we're directly on a taxonomy page, force this taxonomy in all the requests, unless specifically filtered otherwise by the user
        let default_category = jQuery("[data-default-store-cat]").data("default-store-cat");
        if (!search_params.has("store_cat") && default_category) {
            search_params.set("store_cat", default_category);
        }

        //Trigger the content refresh
        machRefreshStores(search_params.toString());
    }

    return false;
}

/**
 * Function making an AJAX request in order to refresh the content based on the filters.
 * @todo: Add a loading screen.
 * @param {string} search_params: Query string containing all the filters
 */
function machRefreshStores(search_params) {
    let $stores_container = jQuery(".stores-algolia-listing .stores-results-container");
    let $pagination_container = jQuery(".stores-algolia-listing .stores-pagination");

    let uri_replace_pattern = /page\/\d+\//g;

    if ($stores_container.length > 0) {
        jQuery.ajax({
            url: backendInfo.ajaxurl + "?" + search_params,
            type: "GET",
            data: {
                action: "mach_filtered_stores",
                current_uri: location.pathname.replace(uri_replace_pattern, ""),
            },
            beforeSend: function () {
                machToggleLoadingScreen();
            },
            success: function (result) {
                let data = JSON.parse(result);
                $stores_container.empty();
                $stores_container.append(data.stores);

                $pagination_container.empty();
                $pagination_container.append(data.pagination);

                machToggleLoadingScreen();

                machToggleMobileStoresFilters(false, true);

                machFixSvgInlineStylesConflicts();

                if (jQuery(document).scrollTop() > 50) {
                    var new_position = jQuery(".stores-algolia-listing").offset();
                    jQuery("html, body")
                        .stop()
                        .animate({ scrollTop: new_position.top - jQuery(".main-header-fixed").innerHeight() }, 500);
                }
            },
        });
    }
}

function machToggleMobileStoresFilters(e, forceClose) {
    if (e) {
        e.preventDefault();
    }

    let $store_categories_filter = jQuery(".stores-algolia-listing .store-categories-filter");
    if (forceClose) {
        $store_categories_filter.addClass("hidden");
        jQuery(".hours-header-preview").removeClass("hidden");
    } else {
        $store_categories_filter.toggleClass("hidden");
        jQuery(".hours-header-preview").toggleClass("hidden");
    }
}

function machStoresHandleScroll() {
    if (jQuery(".stores-algolia-listing").length > 0) {
        var sectionTop = jQuery(".stores-algolia-listing").offset().top;
        var sectionHeight = jQuery(".stores-algolia-listing").outerHeight();
        var scrollPos = jQuery(window).scrollTop() + jQuery(".main-header-fixed").innerHeight();

        // Hide the hours preview if we're currently scrolling the stores list so it doesn't overlap with the filters form
        if (scrollPos > sectionTop && scrollPos < sectionTop + sectionHeight) {
            jQuery(".hours-header-preview").addClass("stores-list-in-view");
        } else {
            jQuery(".hours-header-preview").removeClass("stores-list-in-view");
        }
    }
}
